import React from 'react';
import CompanySaleReportFilter from './CompanySaleReportFilter';
import CompanySaleReportTotal from './CompanySaleReportTotal';
import CompanySaleReportTable from './CompanySaleReportTable';
import { Card, Row, Col } from 'antd';

export default function CompanySaleReport() {   
    
    return (
        <Card className="report-table">
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <CompanySaleReportFilter />
                    </Col>
                    <Col span={24}>
                    <CompanySaleReportTotal/>
                    </Col>
                    <Col span={24}>
                    <CompanySaleReportTable />
                </Col>
            </Row>
        </Card>
    )
}
